import CancellationError from '@/common/utils/errors/CancellationError';
import { takeLastByKey } from '@/common/utils/takeLastByKey';

type TakeLastFn = (abort: AbortController) => Promise<unknown>;

type TakeLastOptions = {
  delay?: number;
  leading?: boolean;
};

// Awaits `takeLastByKey` and swallows the `CancellationError` raised when a newer call
// supersedes the previous one. Without this, every superseded fetch surfaces as an
// unhandled rejection in the console during active replications.
export const takeLastByKeyIgnoreCancel = async (
  fn: TakeLastFn,
  key: string,
  options?: TakeLastOptions
): Promise<void> => {
  try {
    await takeLastByKey(fn, key, options);
  } catch (error) {
    if (error instanceof CancellationError) return;
    throw error;
  }
};
